import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Button from '../../components/Button';
import * as styles from './ControlBarButton.module.scss';

type ControlBarButtonProps = React.HTMLAttributes<HTMLElement> & {
  active?: boolean;
  controlButtonVariant?: 'warning' | 'info' | 'default';
  interactionsDisabled?: boolean;
  icon?: React.ReactNode;
};

const ControlBarButton = forwardRef<
  HTMLButtonElement & HTMLDivElement,
  ControlBarButtonProps
>(
  (
    {
      active,
      className,
      controlButtonVariant = 'default',
      interactionsDisabled,
      children,
      icon,
      ...rest
    },
    ref,
  ) => {
    const Component = interactionsDisabled ? 'span' : Button;

    return (
      <Component
        {...rest}
        ref={ref}
        className={classNames(className, styles.button, {
          [styles.active]: active,
          [styles.danger]: controlButtonVariant === 'warning',
          [styles.info]: controlButtonVariant === 'info',
          [styles.interactionsDisabled]: interactionsDisabled,
        })}
      >
        {!!icon && <span className={styles.icon}>{icon}</span>}
        {!!children && <span className={styles.label}>{children}</span>}
      </Component>
    );
  },
);

export default ControlBarButton;
